import { Brain, FileText, ListTodo, Kanban, Image, Bookmark, Table } from 'lucide-react';
import type { TopicType } from '../types/topic';

// Define the mapping between topic types and their icons
export const TOPIC_ICONS = {
  ai_chat: {
    icon: Brain,
    label: 'AI Chat',
    description: 'Interactive chat with AI assistance',
  },
  notes: {
    icon: FileText,
    label: 'Notes',
    description: 'Personal notes and voice memos',
  },
  list: {
    icon: ListTodo,
    label: 'List',
    description: 'Simple list for tracking items',
  },
  todo: {
    icon: Kanban,
    label: 'Todo Board',
    description: 'Kanban board for task management',
  },
  moodboard: {
    icon: Image,
    label: 'Moodboard',
    description: 'Visual collection of images',
  },
  bookmarks: {
    icon: Bookmark,
    label: 'Bookmarks',
    description: 'Collection of bookmarked websites',
  },
  table: {
    icon: Table,
    label: 'Table',
    description: 'Structured data in a spreadsheet format',
  },
} as const satisfies Record<
  TopicType,
  {
    icon: React.ComponentType;
    label: string;
    description: string;
  }
>;
